import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/contract";

export default {
    /** 分页查询合同列表 */
    queryList: (data) => axios.post({url: `${PREFIX_URI}/queryList`, data: data}),
    /** 查询合同详情（含明细、续费记录、收款记录） */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id: id}}),
    /** 保存合同（含明细） */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data: data}),
    /** 删除合同 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id: id}}),
    /** 合同收款 */
    receipt: (data) => axios.post({url: `${PREFIX_URI}/receipt`, data: data}),
    /** 合同明细续费 */
    renew: (data) => axios.post({url: `${PREFIX_URI}/renew`, data: data}),
    /** 查询合同明细 */
    queryItems: (contractId) => axios.get({url: `${PREFIX_URI}/queryItems`, data: {contractId: contractId}}),
    /** 客户到期预警列表（合同明细） */
    expireList: (data) => axios.get({url: `${PREFIX_URI}/expireList`, data: data}),
    /** 客户到期预警档计数 */
    expireStats: () => axios.get({url: `${PREFIX_URI}/expireStats`}),
    /** 导入客户年费表（异步，formData：file） */
    importExcel: (formData) => axios.post({url: `${PREFIX_URI}/importExcel`, data: formData}),
    /** 查询合同导入状态（前端每5秒轮询） */
    importStatus: () => axios.get({url: `${PREFIX_URI}/importStatus`}),
    /** 合同趋势统计 */
    statTrend: (data) => axios.get({url: `${PREFIX_URI}/statTrend`, data: data}),
    /** 合同概况统计 */
    statDistribution: (data) => axios.get({url: `${PREFIX_URI}/statDistribution`, data: data}),
};
